export const authRoles = {
  sa: ["sa"],
  all: ["admin", "client", "subclient", "locale"],
  admin: ["sa", "admin"],
  client: ["admin", "client"],
  subclient: ["admin", "client", "subclient"],
  editor: ["sa", "admin", "editor"],
  guest: ["sa", "admin", "editor", "guest"],
};
